var React = require('react');

function Circle (props) {
    return React.createElement("svg",props,React.createElement("rect",{"id":"Rectangle-Copy-28","width":"100","height":"100","x":"0","y":"0","rx":"50"}));
}

Circle.defaultProps = {"className":"fill-current stroke-current","version":"1.1","viewBox":"0 0 100 100"};

module.exports = Circle;

Circle.default = Circle;
